import { jamesVanArkel } from './items/james-van-arkel';
import { mikeyHaklander } from './items/mikey-haklander';
import { thomasLek } from './items/thomas-lek';
import { pixel } from './items/pixel';
import { teddy } from './items/teddy';

export const employeesList = [jamesVanArkel, thomasLek, mikeyHaklander, pixel, teddy];
